import { IFlightRefundState } from "@/core/interfaces/IFlightRefunds.interface";

const state: IFlightRefundState = {
  isPNRFetching: false,
  refundPNRDetails: null,
  refundPNR: null,
  canCalculateRefund: false,
  calculateDetails: null,
  refundedDetails: null,
  isCommitingRefund: false,
  isRefundAirlineAndProviderFetching: false,
  refundAirlinesAndProvider: null,
};

export default state;
